import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { StyleSheet, View, } from 'react-native';
import { Typography } from '../typography/Typography';
import Icon from '../icon/Icon';
import { addCommasToNumber } from "../stack/utils";
const EnhancedLimitCard = ({ limitAmount }) => {
    return (React.createElement(View, { style: {
            height: 38,
            backgroundColor: "#F1F3F5",
            borderRadius: 6,
            borderWidth: 1,
            paddingVertical: 8,
            paddingHorizontal: 12,
            borderColor: "#E4E7EC",
            flexDirection: 'row',
            marginHorizontal: 16
        } },
        React.createElement(Icon, { name: IconTokens.InfoIcon, size: IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }),
        React.createElement(View, { style: { marginLeft: 8, flexDirection: 'row' } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "You have an existing credit limit of ", color: ColorTokens.Grey_Charcoal }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: `₹${addCommasToNumber(limitAmount)}`, color: ColorTokens.Grey_Charcoal }))));
};
const styles = StyleSheet.create({
    cardStyle: {
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: '#FFFFFF',
        borderColor: '#E4E7EC',
        padding: 8,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    rupeeImageStyle: {
        width: 22,
        height: 22,
    },
});
export default memo(EnhancedLimitCard);
export { EnhancedLimitCard };
